import React, { Component } from 'react';
import './home.css';
import appicon from './img/appicon.png';
import appstoreBadge from './img/btn-apple-download.svg';
import badge from './img/badge.png';
import Screenshots from '../screenshots/screenshots.js';
import screenshot2 from '../screenshots-img/screenshot2.png';

class Home extends Component {

  render() {

    return (
      <div className="container mt-4">
  		  <div className="row">		
    			<div className="col-md-12 col-12 jumbotron">
            <div className="row">
              <div className="col-md-7 d-none d-md-block">	
                <img src={screenshot2} alt="Screenshot" className="img-rounded img-fluid img-thumbnail"></img>
              </div>
              <div className="col-md-5 col-12">		
                <h1 className="d-none d-sm-block h-red text-center h1-title mobile"><img src={appicon} alt="Pairs icon" className="rounded"/>&nbsp;Pairs</h1>
                <div className="d-block d-sm-none text-center"><img src={appicon} alt="Pairs icon" className="rounded"/></div>
                <div className="d-block d-sm-none text-center"><h5 className= "h-red h5-title">Igrecway Pairs</h5></div>
                <p className="text-center d-none d-sm-block mt-5">
                  <a href="https://itunes.apple.com/app/igrecway-pairs-game/id897087907" role="button"><img src={appstoreBadge} alt="Appstore download"/></a>
                </p>
                <p className="text-center d-block d-sm-none mt-4">
                  <a href="https://itunes.apple.com/app/igrecway-pairs-game/id897087907" role="button"><img src={badge} alt="Appstore download"/></a>
                </p>
                <h3 className="text-center h3-title mt-5">This kids app entertains your little one, while promoting greater concentration and a better memory - all while they have fun!</h3>
              </div>
            </div>
    			</div>
    	  </div>		
  	    <div className="row">  
          <div className="col-md-12 col-12 jumbotron text-center">
            <h2 className="d-none d-sm-block h2-title">Screenshots</h2>
            <h5 className="d-block d-sm-none h-lightblue h5-title">Screenshots</h5>
            
            <Screenshots />
          </div>
        </div>
   
        <div className="row">  
          <div className="col-md-12 col-12 jumbotron description">
            <h2 className="d-none d-sm-block text-center h2-title">Features</h2>
            <h5 className="d-block d-sm-none h-lightblue text-center h5-title">Features</h5>
              <p>          
                The Igrecway Pairs Game is the perfect app for your toddler!</p><p> This kids app entertains your little one, while promoting greater <span className="h-red ic-large">concentration</span> and a better <span className="h-green ic-large">memory</span> - all while they have fun! 
              </p>

              <p>The Igrecway Pairs Game is a <span className="h-plum ic-large">fun</span> and simple game app that toddlers can learn and master quickly, but it's still engaging enough to entertain older children as well.</p> 
           
              <p>We recommend this brain training game app for kids between the <span className="h-orange ic-large">ages of 3 to 6.</span></p> 

            </div>
          </div>
        </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/home/Home.js